import React, { Component } from 'react';
import FlagIconFactory from 'react-flag-icon-css'
import './LanguageMenu.css';
import Divider from 'material-ui/Divider';
import LanguageEnum from '../../enums/LanguageEnum';
import Arrow from 'react-material-icons/icons/navigation/arrow-drop-down';


const FlagIcon = FlagIconFactory(React, { useCssModules: false });

/**
 * Drop Down menu pour le choix de langue
 */
class LanguageMenu extends Component {

    /**
     *
     * @param {*} props  contient :
     * - la langue selectionné ( cf enum LanguageEnum )
     */
    constructor(props) {
        super(props);
        this.state = {
            listIsVisible: false,
            selectedItem: props.selectedItem,
            top: props.top
        };
        this.items = [
            LanguageEnum.en,
            LanguageEnum.es,
            LanguageEnum.fr,
            LanguageEnum.nl
        ];
    }

    select(item) {
        this.setState({
            selectedItem: item,
            listIsVisible: false
        });
        this.props.onChangeAction(item.i18nCode)
    }

    action() {
        this.setState({ listIsVisible: !this.state.listIsVisible });
    }

    renderFixedItem() {
        return (
            <div className="dropDownMenu btn" onClick={this.action.bind(this)}>
                <div className="item"> {this.state.selectedItem.name} </div>
                <div className="item"> <FlagIcon code={this.state.selectedItem.flagCode}/> </div>
                <Arrow className="item"/>
            </div>
        );
    }

    render() {
        let style = {};
        if(!this.state.listIsVisible) {
            style.display = 'none';
        }
        if(this.state.top){
            style.marginTop = '40px';
            style.marginLeft = '-20px';
        }

        return (
            <div>
                <div className="displayList" style={style}>
                    {this.items.map(item =>
                        <div key={item.i18nCode}>
                            <div className="dropDownMenu btn" onClick={() => this.select(item)}>
                                <div className="item"> {item.name} </div>
                                <div className="item"> <FlagIcon code={item.flagCode} /> </div>
                            </div>
                            <Divider/>
                        </div>
                    )}
                </div>
                {this.renderFixedItem()}
            </div>
        );
    }

}

export default LanguageMenu;



// WEBPACK FOOTER //
// ./src/components/languageMenu/LanguageMenu.js